<script>
    export default {
        computed: {
            tvChannels() {
                let channels = this.tvPackage.hd_channels.length;

                if (this.tvPackage.sd_channels) {
                    channels += this.tvPackage.sd_channels.length;
                }

                return channels;
            },
        },
    };
</script>
